module.exports = __webpack_public_path__ + "static/media/special_3.ab239a2a.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/special/special_3.csv
// module id = 739
// module chunks = 0